import { SettleTotal } from './total'

export function Settled() {
    return (
        <SettleTotal />
    )
}
